
import { defineComponent, PropType, ref, watch, onMounted } from "vue";
import { ParserFieldObject, Property } from "@/types";
import { useI18n } from "vue-i18n";

export default defineComponent({
  name: "PositionGrid",

  props: {
    configs: {
      type: Object as PropType<any>,
      required: true
    },

    parserValues: {
      type: Object as PropType<ParserFieldObject>,
      required: true
    }
  },

  emits: ['on-change-properties'],

  setup(props, { emit }) {
    const { t } = useI18n();

    const positions = [
      { value: "tl", row: 1, col: 1 },
      { value: "tc", row: 1, col: 2 },
      { value: "tr", row: 1, col: 3 },
      { value: "ml", row: 2, col: 1 },
      { value: "mc", row: 2, col: 2 },
      { value: "mr", row: 2, col: 3 },
      { value: "bl", row: 3, col: 1 },
      { value: "bc", row: 3, col: 2 },
      { value: "br", row: 3, col: 3 }
    ];

    const hoveredPosition = ref<string | null>(null);

    // Allow center position (mc) - disabled by default
    const allowCenter = props.configs.options?.allowCenter || false;

    const currentPosition = ref(props.configs.options?.defaultValue || "bl");

    // Initialize from parsed values
    const initPosition = () => {
      const property = props.parserValues.properties?.[0];
      if (property?.value) {
        currentPosition.value = property.value;
      }
    };

    onMounted(() => {
      initPosition();
    });

    watch(
      () => props.parserValues.properties,
      () => {
        initPosition();
      },
      { deep: true }
    );

    const selectPosition = (position: string) => {
      currentPosition.value = position;
      const property = props.configs.properties?.[0];
      if (property) {
        const prop: Property = {
          name: property.name,
          getter: property.getter,
          setters: property.setters,
          value: position
        };
        emit('on-change-properties', {
          selector: props.parserValues.selector,
          properties: [prop],
        });
      }
    };

    return {
      t,
      positions,
      currentPosition,
      hoveredPosition,
      allowCenter,
      selectPosition
    };
  }
});
